import React from "react";
import Modal from "react-modal";

export function AssignStoreLocationModal({
  isOpen,
  storeLocationChanged,
  storeLocationLabel,
  onAssign,
  onClose,
}) {
  return (
    <Modal isOpen={isOpen} contentLabel="Add Note" className="confirm-modal">
      <form className="m-10">
        <div className="card">
          <div className="card-header">Assigned Store Location</div>
          <div className="card-body">
            <div className="mb-3">
              {storeLocationChanged ? (
                `Confirm Assign store location to ${storeLocationLabel}?`
              ) : (
                <div>Please assign store location first. </div>
              )}
            </div>
            <button
              disabled={!storeLocationChanged}
              type="button"
              className="btn btn-outline-primary mr-3"
              data-testid="button-assign-to"
              onClick={onAssign}
            >
              Assign
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
